










































import {defineComponent} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import STextarea from '@/common/components/STextarea.vue';

export default defineComponent({
  name: 'UCIrvineELN1v2Safety2',
  components: {STextarea, StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        safety2Answer: null,
      },
      attachments: [] as File[],
      questions: [
        {
          text: 'Provide answers to the questions in Project #1 document for the assigned GHS symbol.',
          inputName: 'safety2Answer',
        },
      ],
    };
  },
});
